
import store from '../store';

export default {

	requestSid()
	{
		return new Promise((resolve, reject) => {
			BX.ajax.runAction('redsign:eshop24.api.captcha.getCaptchaSid')
				.then(resolve, reject);
		});
	},

	async updateSid(form)
	{
		try
		{
			const sid = form.querySelector(`input[type="hidden"][name="captcha_sid"]`);
			const image = form.querySelector(`img[src*="/bitrix/tools/captcha.php"]`);
			const result = await this.requestSid();
			if (result.status === 'success')
			{
				const newSid = result.data;
				sid.value = newSid;
				image.src = `/bitrix/tools/captcha.php?captcha_sid=${newSid}`
			}
		}
		catch(e)
		{
			console.error(e);
		}
	}

}